<label for="destination" class="bmd-label-static">Destination</label>
<select
    *ngIf="(clients || []).length > 1"
    class="form-control mt-2 mb-5"
    [(ngModel)]="targetClientId"
    name="destination"
    (change)="targetClientSelectionChanged($event)"
>
    <optgroup label="Global">
        <option [ngValue]="null">
            Template Library
        </option>
    </optgroup>
    <optgroup label="Jurisdictions">
        <option *ngFor="let client of clients" [value]="client.id">
            {{ client.name }}
        </option>
    </optgroup>
</select>

<wm-modal-confirm
    #confirmChangeTargetModal
    title="Change Destination"
    moduleId="change-destination"
    [showButton]="false"
    commandText="Yes, Change Destination"
    cancelText="No"
    (accepted)="switchTargetClients()"
    (canceled)="cancelSwitchTargetClients()"
>
  Are you sure you want to change the jurisdiction to which you are copying this workflow?  Doing so will cause all settings to be cleared.
</wm-modal-confirm>

<wm-map-workflow-settings
    *ngIf="firstTargetClientSelectionMade && !changingTargetClient"
    [sourceWorkflowId]="workflowId"
    [targetJurisdictionId]="targetClientId"
    [useTargetJurisdictionInput]="true"
></wm-map-workflow-settings>